import type {PropertyManager} from "../types";

/** Lowest `id` when multiple managers are assigned (per product rule). */
export function pickPrimaryPropertyManager(
  managers: PropertyManager[] | null | undefined,
): PropertyManager | null {
  if (!managers?.length) return null;
  return managers.reduce((lowest, manager) => (manager.id < lowest.id ? manager : lowest));
}

export function formatPropertyManagerDisplayName(manager: PropertyManager): string {
  return [manager.first_name, manager.last_name].filter((part) => part?.trim()).join(" ").trim();
}

export const AMENITY_RESTRICTION_REFERRAL_LEAD =
  "Resident's amenity access is currently suspended. Please refer the resident to property management for further assistance.";

export type AmenityRestrictionReferralMessage = {
  lead: string;
  propertyManagerLine: string | null;
};

export function formatPropertyManagerContactLine(manager: PropertyManager): string | null {
  const parts = [
    formatPropertyManagerDisplayName(manager),
    manager.email?.trim(),
    manager.telephone?.trim(),
  ].filter((part): part is string => Boolean(part?.length));

  if (parts.length === 0) return null;
  return `Property Manager: ${parts.join(" | ")}`;
}

export function buildAmenityRestrictionReferralMessage(
  managers: PropertyManager[] | null | undefined,
): AmenityRestrictionReferralMessage {
  const manager = pickPrimaryPropertyManager(managers);
  return {
    lead: AMENITY_RESTRICTION_REFERRAL_LEAD,
    propertyManagerLine: manager ? formatPropertyManagerContactLine(manager) : null,
  };
}
